export class DevOpsAlarm {
    alarmKind?: string;
    accountId?: string;
    environmentId?: string;
    resourceName?: string;
    alarmId?: string;
    serviceLevel?: string;
    cdoSeverity?: string;
    region?: string;

    alarmName?: string;
    alarmState?: string;
    description?: string;
    namespace?: string;
    metricName?: string;
}
